var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59617 8.02887L4.59702 8.02972C4.73414 8.16543 4.91397 8.23439 5.09377 8.23439C5.27358 8.23439 5.45341 8.16543 5.59053 8.02972L12.1543 1.46595C12.4281 1.19076 12.4281 0.746767 12.1543 0.471586L12.1535 0.47074C11.8783 0.196963 11.4338 0.197399 11.1587 0.471176L5.09378 6.53696L1.84095 3.28324C1.56577 3.00946 1.12177 3.00946 0.846592 3.28324L0.845746 3.28409C0.571969 3.55927 0.572393 4.00369 0.846169 4.27887L4.59617 8.02887ZM1.31858 3.31295C1.20711 3.31891 1.09734 3.36439 1.0119 3.44939C0.829085 3.63314 0.829085 3.92939 1.0119 4.11314L4.7619 7.86314C4.85377 7.95408 4.97377 8.00002 5.09377 8.00002C5.10225 8.00002 5.11072 7.99979 5.11918 7.99933C5.11079 7.99978 5.10239 8.00001 5.09398 8.00001C4.97398 8.00001 4.85398 7.95407 4.76211 7.86313L1.01211 4.11313C0.829297 3.92938 0.829297 3.63313 1.01211 3.44938C1.0975 3.36443 1.20718 3.31895 1.31858 3.31295ZM11.6318 0.500419C11.52 0.506223 11.41 0.551714 11.3244 0.636892L5.09388 6.86834L5.09398 6.86844L11.3246 0.636881C11.4102 0.551756 11.5201 0.506269 11.6318 0.500419Z",
    fill: "#05690D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.e53f275316fcc93a18e134cf3da7a6e5.svg";
export { ForwardRef as ReactComponent };